import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers/index';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { routerMiddleware } from 'react-router-redux';
import createBrowserHistory from 'history/createBrowserHistory';
import { autoRehydrate } from 'redux-persist';

const sessionStore = autoRehydrate(); // create state session Store
const history = createBrowserHistory(); // history browser

//Dev
/*
const logger = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const middlewareRoute = routerMiddleware(history);

const arrMiddle = [logger, sagaMiddleware, middlewareRoute];
const createStoreWithMiddleware = composeEnhancers(applyMiddleware(...arrMiddle),sessionStore)(createStore);
*/

//Proc
const composeEnhancers =  compose;
const sagaMiddleware = createSagaMiddleware();
const middlewareRoute = routerMiddleware(history);
const arrMiddle = [ sagaMiddleware, middlewareRoute];
const createStoreWithMiddleware = composeEnhancers(applyMiddleware(...arrMiddle),sessionStore)(createStore);

export function configureStore(initialState) {
    return {
        ...createStoreWithMiddleware(rootReducer, initialState),
        runSaga: sagaMiddleware.run
    }
}


// WEBPACK FOOTER //
// ./src/store.js